import React, { createContext, useMemo } from 'react'
import { omitBy, isUndefined } from '@golden/utils'
import Grid from '@material-ui/core/Grid'
import MuiTextField, { TextFieldProps } from '@material-ui/core/TextField'
import MuiButton from '@material-ui/core/Button'
import SearchIcon from '@material-ui/icons/Search'
import FormStateProvider from '../../default/form/FormStateProvider'
import FormField from '../../default/form/FormField'
import FormSubmitButton from '../../default/form/FormSubmitButton'
import { useRequestFromSearch, useChangeUrlSubmit } from '../../../utils/default/ComplexFlowHook'
import { useCommonStyles } from '../../../utils/admin/StyleHook'
import { createDefaultFormState, FormValidation, ValueGetter } from '../../../utils/default/FormHook'
import { getValueFromChangeEvent, convertEmptyToUndefined } from '../../../utils/default/FormHelper'
import allRoute from '../route/route'
import useT from '../../../i18ns/admin/useT'
import { AgentAnnouncementRequestType, searchToRequest } from '../../../views/admin/forestage/AgentAnnouncementPage'

interface AgentAnnouncementFormType {
  account: string
}

const formToRequest = (form: AgentAnnouncementFormType): AgentAnnouncementRequestType => {
  const data = {
    page: 1,
    account: convertEmptyToUndefined(form.account)
  } as AgentAnnouncementRequestType
  return omitBy(data, isUndefined) as AgentAnnouncementRequestType
}

const validation: FormValidation<AgentAnnouncementFormType> = {
  account: []
}

const getValueFromEvent: ValueGetter<AgentAnnouncementFormType> = {
  account: getValueFromChangeEvent
}

const FormContext = createContext(createDefaultFormState({
  account: ''
}))

const TextField = React.memo(MuiTextField)

const Button = React.memo(MuiButton)

const AgentAnnouncementForm: React.FC = () => {
  const classes = useCommonStyles()
  const { t } = useT()
  const request = useRequestFromSearch({ searchToRequest })
  const defaultForm = useMemo(() => ({ account: request?.account ?? '' }), [request])
  const handleSubmit = useChangeUrlSubmit({
    toAddNowTimestamp: true,
    formToRequest,
    encodePath: allRoute.forestageAgentAnnouncement.encodePath
  })
  return (
    <Grid container justifyContent="flex-end">
      <FormStateProvider
        context={FormContext}
        defaultValue={defaultForm}
        onSubmit={handleSubmit}
        getValueFromEvent={getValueFromEvent}
        validation={validation}
      >
        <Grid container spacing={2} alignItems="flex-end">
          <Grid item>
            <Grid container spacing={1} alignItems="flex-end">
              <Grid item>
                <SearchIcon />
              </Grid>
              <Grid item>
                <FormField<AgentAnnouncementFormType, TextFieldProps>
                  context={FormContext}
                  component={TextField}
                  name="account"
                  placeholder={t('placeholder.inputSearchAccount')}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <FormSubmitButton
              context={FormContext}
              component={Button}
              className={classes.pinkGradualButton}
              type="submit"
            >
              {t('common.search')}
            </FormSubmitButton>
          </Grid>
        </Grid>
      </FormStateProvider>
    </Grid>
  )
}

export default React.memo(AgentAnnouncementForm)
